import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useSelectedLocations } from '@frontend/payments-hooks';
import { PaymentsFlowType, StripeElementsWrapper } from '@frontend/payments-stripe-wrapper';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { PaymentSettingsCard, PaymentSettingsGroup } from '../atoms';
import { TerminalSettings, TerminalAddress, TerminalSettingsAction, useTerminalSettings } from '../sections';

export const TerminalSettingsGroup = () => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  const { locationIds } = useSelectedLocations();
  return (
    <section>
      <StripeElementsWrapper mode='setup' type={PaymentsFlowType.Terminal}>
        {locationIds.length === 1 ? (
          <PaymentSettingsCard title={t('Terminals')} action={<TerminalSettingsAction />}>
            <TerminalAddress />
            <TerminalSettings />
          </PaymentSettingsCard>
        ) : (
          <PaymentSettingsGroup>
            <TerminalSettingsActions />
            <TerminalSettings />
          </PaymentSettingsGroup>
        )}
      </StripeElementsWrapper>
    </section>
  );
};

const styles = {
  actionHeader: css`
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.spacing(2)};
    @media (min-width: ${breakpoints.medium.min}) {
      flex-direction: row;
      justify-content: space-between;
    }
  `,
};

const TerminalSettingsActions = () => {
  const { hasTerminalsEnabled } = useTerminalSettings();

  if (!hasTerminalsEnabled) return;
  return (
    <div css={styles.actionHeader}>
      <TerminalAddress />
      <TerminalSettingsAction />
    </div>
  );
};
